import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { Input } from '../../../components/common/Input/index.js';
import { emailSelector, updateEmail, updateEmailError, updateEmailErrorMessage, } from '../resetPasswordSlice.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { accountIdentifierEmailSelector } from '../../AccountIdentifier/accountIdentifierSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const ResetPasswordEmailInput = () => {
    const { t } = useTranslation();
    const emailState = useAppSelector(emailSelector);
    const dispatch = useAppDispatch();
    const accountIdentifierEmail = useAppSelector(accountIdentifierEmailSelector);
    const { trackFieldError } = useTrack('resetPassword');
    useEffect(() => {
        dispatch(updateEmail(accountIdentifierEmail.value));
    }, []);
    const onBlurEmail = ({ target }) => {
        const emailString = target.value;
        const hasError = !validateEmail(emailString);
        dispatch(updateEmailError(hasError));
        if (hasError) {
            trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
        }
    };
    const emailOnChange = ({ target }) => {
        const { value } = target;
        dispatch(updateEmail(value));
    };
    const { value, error, errorMessage } = emailState;
    return (_jsx(Input, { dataTestId: "email-input", value: value, onChange: emailOnChange, type: 'email', name: 'email', formLabel: t('loginregistration.registration.email.headerInput'), placeholder: t('loginregistration.registration.email.placeholder'), hasError: error, errorText: errorMessage, onBlur: onBlurEmail, autoComplete: 'username' }));
};
//# sourceMappingURL=ResetPasswordEmailInput.js.map